/** Narration shorter than this prints in full: an overlay's words, which the model times reveals to. */
export const COMPACT_NARRATION_ABOVE_WORDS = 30;
/** Words kept at each end of compacted narration: enough to read exactly where it starts and stops. */
const FENCE_POST_WORDS = 8;

/** `tokens` as their first and last few, with a count of what's between; unchanged when short. */
export function fencePosts(tokens: string[]): string {
    if (tokens.length <= COMPACT_NARRATION_ABOVE_WORDS) {
        return tokens.join(' ');
    }
    const head = tokens.slice(0, FENCE_POST_WORDS);
    const tail = tokens.slice(-FENCE_POST_WORDS);
    const omitted = tokens.length - head.length - tail.length;
    // Tag-like so it can't be read as, or copied along with, the transcript's own words.
    return `${head.join(' ')} <${omitted.toLocaleString('en-US')} more words> ${tail.join(' ')}`;
}
